import { FC } from 'react';
import { IoMdSettings } from 'react-icons/io';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useToggle } from '../../../../../../../hooks/use-toggle';
import {
  DashboardChartsWidgetModal,
  DashboardChartsWidgetModalType,
} from './dashboard-charts-widget-modal/dashboard-charts-widget-modal';

export const DashboardChartsWidget: FC<DashboardChartsWidgetModalType> = (props) => {
  const [openWidget, , setOpenWidget] = useToggle();
  const { t } = useLang();

  const isRenderWidget = !!props.invalidData || !!props.filters;

  if (!isRenderWidget) return null;

  return (
    <>
      {!openWidget && (
        <IconButton
          variant="secondary"
          size="sm"
          tooltip={t('Настройки')}
          onClick={() => setOpenWidget(true)}
        >
          <IoMdSettings />
        </IconButton>
      )}
      {openWidget && <DashboardChartsWidgetModal {...props} onClose={() => setOpenWidget(false)} />}
    </>
  );
};
